import * as React from 'react';
export const useGridInitializeState = (initializer, apiRef, props) => {
  const isInitialized = React.useRef(false);

  if (!isInitialized.current) {
    apiRef.current.state = initializer(apiRef.current.state, props, apiRef);
    isInitialized.current = true;
  }
};


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/utils/useGridInitializeState.js
// module id = 2367
// module chunks = 25